import { cn } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'

export type TTrialCountdown = {
	expiresAt?: Date
	expired?: boolean
	days?: number
	hours?: number
	minutes?: number
	seconds?: number
}

const TrialSingleCountdown = ({
	value,
	label,
}: {
	value: number
	label: string
}) => {
	const t = useTranslations()
	const prefixWithZero = value.toString().padStart(2, '0')
	const isError = value === 0

	return (
		<div className="flex flex-col items-center justify-center">
			<p
				className={cn('type-heading-2', isError ? 'text-error' : 'text-black')}
			>
				{prefixWithZero}
			</p>
			<span
				className={cn(
					'text-body-medium uppercase',
					isError ? 'text-error' : 'text-grey',
				)}
			>
				{t(label)}
			</span>
		</div>
	)
}

export const TrialCountdown = ({
	trialCountDown,
}: {
	trialCountDown: TTrialCountdown
}) => {
	const days = trialCountDown.days ?? 0
	const hours = trialCountDown.hours ?? 0
	const minutes = trialCountDown.minutes ?? 0

	return (
		<div className="flex gap-8">
			<TrialSingleCountdown
				value={days}
				label="dashboard__trial_expired__modal__trial_countdown_days"
			/>
			<TrialSingleCountdown
				value={hours}
				label="dashboard__trial_expired__modal__trial_countdown_hours"
			/>
			<TrialSingleCountdown
				value={minutes}
				label="dashboard__trial_expired__modal__trial_countdown_minutes"
			/>
		</div>
	)
}
